<template>
  <div class="td-links-wrap">
    <div v-if="data.status == ReportStatus.WaitingSurvey || data.status == ReportStatus.LabsWaitingSurvey" class="td-text text-warning">
      <span>Waiting for Patients Survey</span>
      <svg-icon v-if="data.hasReqDocument && data.status == ReportStatus.LabsWaitingSurvey"
                class="ml-1 pdf-icon req clickable"
                size="32"
                name="pdf"
                @click="$emit('on-download-req', data)" />
    </div>
    <div v-if="data.status == ReportStatus.WaitingReview" class="td-text text-warning">
      <span>Preparing Labwork Order</span>
    </div>
    <div v-if="data.status == ReportStatus.WaitingResults || data.status == ReportStatus.FinalProcessing" class="td-text text-warning d-flex align-items-center justify-content-between">
      <span>Waiting for Lab Result</span>
      <svg-icon v-if="data.hasReqDocument && data.labworkType === LabworkType.Internal" class="ml-1 pdf-icon req clickable" size="32" name="pdf" @click="$emit('on-download-req', data)"></svg-icon>
    </div>
    <div v-if="data.status == ReportStatus.Cancelled" class="td-text text-danger">
      <span>Cancelled</span>
    </div>
    <div v-if="data.status == ReportStatus.Completed" class="d-flex align-items-center justify-content-between">
      <span class="td-text text-success">Completed</span>
      <svg-icon class="pdf-icon clickable" size="32" name="pdf" @click="$emit('on-download-report', data)"></svg-icon>
    </div>
    <div v-if="data.status == ReportStatus.OrderLabsFirst" class="d-flex align-items-center justify-content-between">
      <span class="td-text text-warning">Order Labs First</span>
      <svg-icon v-if="data.hasReqDocument" class="ml-1 pdf-icon req clickable" size="32" name="pdf" @click="$emit('on-download-req', data)"></svg-icon>
    </div>
    <div v-if="data.status == ReportStatus.OrderOnHold" class="d-flex align-items-center justify-content-between">
      <span class="td-text text-warning">Order On Hold</span>
      <svg-icon v-if="data.hasReqDocument" class="ml-1 pdf-icon req clickable" size="32" name="pdf" @click="$emit('on-download-req', data)"></svg-icon>
    </div>
  </div>
</template>

<script>
  import ReportStatus from 'enums/report-status';
  import LabworkType from 'enums/labwork-type';

  export default {
    props: {
      data: Object,
    },

    data() {
      return {
        ReportStatus,
        LabworkType
      }
    }
  };
</script>